<div class="loader-overlay" [ngClass]="{ 'show': isLoading }">
  <div class="loader-content" [ngClass]="{'appear-as-modal': appearAsModal}">
    <!-- <span class="loader-text">Loading...</span> -->

    <!--if loader type is spinner we will show cds-progress spinner-->
    <div *ngIf="loaderType === 'SPINNER'">
      <cds-progress mode="indeterminate" type="ring" [diameter]="diameter"></cds-progress>
    </div>

    <!--loader text-->
    <div class="loader-content__text" *ngIf="loaderText">
      {{ loaderText }}
    </div>
  </div>
</div>